import customAxios from "../../customAxios";

import { LOCATION_CITY } from "../../routes";
import {locationNamespace} from "../../../types/location.namespace";

const searchCity = async (props: locationNamespace.city.request): Promise<any> => {
  let thisUrl: string = `${LOCATION_CITY}?`;

  if (props?.search && props.search.trim().length > 0) thisUrl += `&search=${props.search}`;

  if (props?.province) thisUrl += `&province=${props?.province}`;
  if (props?.limit   ) thisUrl += `&limit=${props?.limit}`;
  if (props?.page    ) thisUrl += `&page=${props.page}`;

  try {
    return (await customAxios.get(thisUrl)).data;
  } catch (error: any) {
    console.log({LOCATION_CITY: error});
  }
};

export default searchCity;
